import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useRef, useState } from 'react';
import CurrentPositionTrigger from '../CurrentPositionTrigger';
import PlacesAutocomplete from 'react-places-autocomplete';
import { useFormApi } from 'informed';
import Button from '@magento/venia-ui/lib/components/Button';
import SearchSuggestions from './SearchSuggestions';
import defaultClasses from '../storeSearch.module.css';
import { useStyle } from '@magento/venia-ui/lib/classify';
import LocationInput from './LocationInput';
import { LocationIcon, SelectField } from 'src/components';
import CustomSelect from '../../../../../../components/CustomSelect';
import Field from '@magento/venia-ui/lib/components/Field';

var SearchForm = function SearchForm(props) {
  var address = props.address,
      setAddress = props.setAddress,
      handleSelect = props.handleSelect,
      setCoordinates = props.setCoordinates,
      setIsMarkerShown = props.setIsMarkerShown,
      findRetail = props.findRetail,
      radius = props.radius,
      handleChange = props.handleChange,
      resetSearch = props.resetSearch,
      showResetSearch = props.showResetSearch,
      setShowResetSearch = props.setShowResetSearch,
      newPosition = props.newPosition,
      getGeolocation = props.getGeolocation;
  var formApi = useFormApi();
  var classes = useStyle(defaultClasses, props.classes);
  var inputRef = useRef();

  var resetSearchFn = function resetSearchFn() {
    return resetSearch();
  };

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showOptions = _useState2[0],
      setShowOptions = _useState2[1];

  return React.createElement("div", {
    className: "".concat(classes.searchForm)
  }, React.createElement(PlacesAutocomplete, {
    value: address,
    onChange: function onChange(e) {
      setAddress(e);
      setShowOptions(true);
    },
    onSelect: function onSelect(e) {
      return handleSelect(e, formApi === null || formApi === void 0 ? void 0 : formApi.getValue('radius'));
    },
    searchOptions: {
      types: ['postal_code', 'locality', 'political'],
      componentRestrictions: {
        country: ['us', 'ca']
      }
    },
    ref: inputRef
  }, function (_ref) {
    var getInputProps = _ref.getInputProps,
        suggestions = _ref.suggestions,
        getSuggestionItemProps = _ref.getSuggestionItemProps,
        loading = _ref.loading;
    return React.createElement(React.Fragment, null, React.createElement("div", {
      className: "flex flex-col relative ".concat(window.location.pathname.includes('buy-local') ? 'md_flex-row' : '', " w-full")
    }, React.createElement("div", {
      className: "location-address-wrapper flex flex-col relative w-full mb-5 md_mb-0 mr-0 md_mr-3"
    }, React.createElement("div", {
      className: "".concat(classes.locationContainer, " ").concat((suggestions === null || suggestions === void 0 ? void 0 : suggestions.length) > 0 ? classes.suggestionsActive : '')
    }, React.createElement(LocationInput, _extends({}, getInputProps(), {
      formApi: formApi
    })), React.createElement("div", {
      className: "".concat(classes.locationIconWrap)
    })), showOptions && React.createElement(SearchSuggestions, {
      suggestions: suggestions,
      getSuggestionItemProps: getSuggestionItemProps,
      loading: loading,
      address: address
    })), React.createElement("div", {
      className: "".concat(classes.radiusSelect, " radius-select-wrapper w-full")
    }, React.createElement(Field, {
      id: "radius",
      label: "Radius"
    }, React.createElement(CustomSelect, {
      options: [{
        label: "25 miles",
        value: '25',
        zoom: 10
      }, {
        label: "50 miles",
        value: '50',
        zoom: 9.5
      }, {
        label: "100 miles",
        value: '100',
        zoom: 9
      }, {
        label: "150 miles",
        value: '150',
        zoom: 8.5
      }],
      field: "radius",
      id: "radius",
      placeholder: "Radius",
      onClick: function onClick(option) {
        handleChange(option);
        setIsMarkerShown(true);
        setShowResetSearch(true);
        findRetail(newPosition.lat, newPosition.lng, option.value);
        setShowOptions(false);
      }
    })))));
  }));
};

export default SearchForm;